//
//
//
//
//
//
//
//
//
//
//

import util from '@/libs/util'
import common from '@/libs/common.mixin'

export default{
	mixins: [common],
	data () {
		return {
			data: {
				broadcast:''
			}
		}
	},
	mounted () {
		this.init_data()
	},
	methods: {			
		init_data () {
			this.$rest('share/broadcast_detail')
			.get({
				bcp_id:this.$route.params.id
			})
			.success(data=>{
				if(data.read_time==0) {
					this.do_read(data.bcp_id)
				}
				this.data = data
				util.title(data.title,this.$store.state.sys_name)
			})
			.error(res => {
				this.$Message.error(res.body.message)
			})
		},
		do_read(id) {
			this.$rest('share/broadcast_read')
			.post({
				bcp_id:id
			})
			.success(res => {

			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/public/news-detail.vue